// Keyboard driving model: legacy WASD throttle/brake/steer vs.
// differential Q/E + Space e-brake (twin-engine keyboard equivalent
// of the mobile twin-stick mode). Persisted across sessions. Default
// keeps existing players on WASD; opt-in for the differential mode.

const STORAGE_KEY = 'tst:keyboard-drive-mode';

export type KeyboardDriveMode = 'wasd' | 'differential';

type Listener = (mode: KeyboardDriveMode) => void;

const listeners = new Set<Listener>();
let mode = readMode();

export const keyboardDriveMode = {
  get(): KeyboardDriveMode {
    return mode;
  },
  set(next: KeyboardDriveMode): void {
    if (next === mode) return;
    mode = next;
    writeMode(next);
    for (const l of listeners) l(next);
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

function readMode(): KeyboardDriveMode {
  try {
    const raw = typeof localStorage?.getItem === 'function'
      ? localStorage.getItem(STORAGE_KEY)
      : null;
    return raw === 'differential' ? 'differential' : 'wasd';
  } catch {
    return 'wasd';
  }
}

function writeMode(value: KeyboardDriveMode): void {
  try {
    if (typeof localStorage?.setItem === 'function') {
      localStorage.setItem(STORAGE_KEY, value);
    }
  } catch {
    // Ignore storage failures in embedded/test environments.
  }
}
